export default __webpack_public_path__ + "static/SRF 4420 - Fiche de spécifications et données techniques-0b8f2112bb79381f6ce9423d444142ec.pdf";